import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-cell-two-button-renderer',
    templateUrl: './cell-two-button-renderer.component.html',
    styleUrls: ['./cell-two-button-renderer.component.scss'],
    standalone: false
})
export class CellTwoButtonRendererComponent {
     cellValue: string = '';
     params: any = {};
     public displayValue!: string;
     paramStore: any = {};

     hideButton: boolean = false;
     // showHideButtonText: boolean = false;
     hideButtonText: string = '';
     buttonText: string = '';
     buttonClass: string = 'btn btn-primary btn-sm';
     buttonIcon: string = '';
     buttonName: string = '';
     buttonTitle: string = '';

     hideButton2: boolean = true;
     showHideButton2Text: boolean = true;
     hideButton2Text: string = '';
     button2Text: string = '';
     button2Class: string = 'btn btn-secondary btn-sm';
     button2Icon: string = '';
     button2Name: string = '';
     button2Title: string = '';

     buttonClick(params: any) {
          if (this.paramStore!.hasOwnProperty('buttonClick')) {
               this.paramStore.buttonClick(this.paramStore!.data!.authCode);
          }
     }

     button2Click(params: any) {
          if (this.paramStore!.hasOwnProperty('button2Click')) {
               this.paramStore.button2Click(this.paramStore!.data!.authCode);
          }
     }

     agInit(params: ICellRendererParams): void {
          this.setValues(params)
          
     }

     refresh(params: ICellRendererParams): boolean {
          this.setValues(params);
          this.paramStore = params;
          this.cellValue = this.getValueToDisplay(params);
          return true;
     }

     // Check if properties have been set in params and, if so, assign to control props.
     setValues(params: ICellRendererParams) {
          this.displayValue = params.value;
          this.paramStore = params;

          // Button 1
          if ('buttonText' in params) {
               this.buttonText = params['buttonText'] as string;
          }
          if ('buttonName' in params &&
               typeof params.buttonName === 'function') {
               this.buttonName = params.buttonName(params);
          }
          if ('buttonClass' in params) {
               this.buttonClass = params['buttonClass'] as string;
          }
          if ('buttonIcon' in params) {
               this.buttonIcon = params['buttonIcon'] as string;
          }
          if ('hideButton' in params &&
               typeof params.hideButton === 'function') {
               this.hideButton = params.hideButton(params);
          }
          if ('hideButtonText' in params) {
               this.hideButtonText = params['hideButtonText'] as string;
          }
          if ('buttonTitle' in params) {
               this.buttonTitle = params['buttonTitle'] as string;
          }

          // Button 2
          if ('button2Text' in params) {
               this.button2Text = params['button2Text'] as string;
          }
          if ('button2Name' in params &&
               typeof params.button2Name === 'function') {
               this.button2Name = params.button2Name(params);
          }
          if ('button2Class' in params) {
               this.button2Class = params['button2Class'] as string;
          }
          if ('button2Icon' in params) {
               this.button2Icon = params['button2Icon'] as string;
          }
          if ('hideButton2' in params &&
               typeof params.hideButton2 === 'function') {
               this.hideButton2 = params.hideButton2(params);
          }
          if ('hideButton2Text' in params) {
               this.hideButton2Text = params['hideButton2Text'] as string;
          }
          if ('button2Title' in params) {
               this.button2Title = params['button2Title'] as string;
          }
     }

     getValueToDisplay(params: ICellRendererParams) {
          return params.valueFormatted ? params.valueFormatted : params.value;
     }
}
